module.exports = __webpack_public_path__ + "01f43047/img/arrow-share-icon.00a12c29.svg";